var displaydNumbers = false;
$(document).ready(function () {
    $('.count-number').waypoint(function () {
        if (!displaydNumbers) {
            $('.count-number').each(function (i, e) {
                $(this).animateNumber({
                    number: parseInt($(this).html()),
                    numberStep: $.animateNumber.numberStepFactories.separator('.')
                }, 1000);
            });
        }
        displaydNumbers = true;
    }, {offset: 'bottom-in-view'});
});